import React, { useEffect, useState } from "react";
import { MdWifiOff } from "react-icons/md";
import { subscribeSlowNetwork } from "../../lib/utils/slowNetwork";

const SlowNetworkOverlay: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    return subscribeSlowNetwork(setIsVisible);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-[100] bg-black/55 backdrop-blur-md sm:backdrop-blur-lg flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-xl px-6 py-5 max-w-sm w-full text-center border border-gray-200">
        <div className="flex justify-center mb-3">
          <MdWifiOff className="text-4xl text-red-500" />
        </div>
        <p className="text-base font-semibold text-gray-900">
          Internet connection is slow
        </p>
        <p className="text-sm text-gray-500 mt-1">
          Please wait while we load your data.
        </p>
      </div>
    </div>
  );
};

export default SlowNetworkOverlay;
